import React, { useEffect, useState } from "react";
import { createPortal } from "react-dom";
import { api } from "@/lib/api";
import CguScrollAccept from "@/components/price/CguScrollAccept";

// Case CGU de l'inscription : elle ne se coche qu'après lecture complète du texte.
export default function SignupCguCheckbox({ checked, onChange, onVersion, testid }) {
  const [open, setOpen] = useState(false);
  const [version, setVersion] = useState(undefined);
  useEffect(() => {
    api.get("/cgu/current").then(({ data }) => { setVersion(data.version); onVersion?.(data.version); }).catch(() => setVersion(null));
  }, [onVersion]);

  const toggle = (e) => {
    if (!version) return onChange(e.target.checked);
    if (checked) onChange(false); else setOpen(true);
  };

  return (
    <div className="rounded-2xl bg-white p-3 street-border-thin">
      <label className="flex items-start gap-2 text-[13px] font-bold">
        <input type="checkbox" checked={checked} onChange={toggle} className="mt-0.5 h-4 w-4 accent-[#1E0910]" data-testid={`${testid}-checkbox`} />
        <span>
          J&apos;ai lu et j&apos;accepte les{" "}
          <button type="button" onClick={() => (version ? setOpen(true) : window.open("/cgu", "_blank"))} className="font-black text-primary underline" data-testid={`${testid}-open`}>Conditions Générales d&apos;Utilisation</button>
          {" "}de Price Covoit.
        </span>
      </label>
      {open && version && createPortal(
        <div className="fixed inset-0 z-[96] flex items-end justify-center bg-black/60 sm:items-center sm:p-4" data-testid={`${testid}-dialog`}>
          <div className="flex max-h-[94vh] w-full max-w-2xl flex-col rounded-t-3xl bg-[#FFF8F1] street-border sm:rounded-3xl animate-in slide-in-from-bottom-6 duration-300">
            <CguScrollAccept version={version} testid={`${testid}-reader`} intro="lis-les jusqu'en bas pour finaliser ton inscription."
              onAccept={() => { onChange(true); setOpen(false); }} onRefuse={() => { onChange(false); setOpen(false); }} refuseLabel="Fermer" />
          </div>
        </div>, document.body,
      )}
    </div>
  );
}

export async function recordSignupCgu(version) {
  if (!version?.id) return;
  try {
    await api.post("/cgu/accept", { version_id: version.id, method: "signup", scrolled_to_end: true });
    // CguGate a pu interroger /cgu/me avant l'enregistrement : on relance sa vérification.
    window.dispatchEvent(new Event("price:cgu-required"));
  } catch (_) { /* rattrapé par CguGate */ }
}
